declare namespace $ {

	type $mol_view__style_shm_hitalama_taskmanager_priority_1 = $mol_type_enforce<
		({ 
			'backgroundColor': ReturnType< $shm_hitalama_taskmanager_priority['value_color'] >,
		})  & ReturnType< $mol_view['style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__style_shm_hitalama_taskmanager_priority_2 = $mol_type_enforce<
		({ 
			'backgroundColor': ReturnType< $shm_hitalama_taskmanager_priority['priority_color'] >,
		})  & ReturnType< $mol_view['style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_dimmer__haystack_shm_hitalama_taskmanager_priority_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_taskmanager_priority['option_label'] >
		,
		ReturnType< $mol_dimmer['haystack'] >
	>
	type $mol_dimmer__needle_shm_hitalama_taskmanager_priority_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_dimmer['needle'] >
	>
	export class $shm_hitalama_taskmanager_priority extends $mol_select {
		priority_dictionary( ): ({ 
			'low': string,
			'normal': string,
			'high': string,
		}) 
		value_color( ): string
		Dot( ): $mol_view
		priority_color( id: any): string
		Option_dot( id: any): $mol_view
		Option_label( id: any): $mol_dimmer
		dictionary( ): ReturnType< $shm_hitalama_taskmanager_priority['priority_dictionary'] >
		Filter( ): any
		Trigger_icon( ): any
		trigger_content( ): readonly(any)[]
		option_content( id: any): readonly(any)[]
	}
	
}

//# sourceMappingURL=priority.view.tree.d.ts.map